/**
 * @generated SignedSource<<0c2b4e9383d426cb441f813dea798358>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoJsonGeomType = "POINT" | "%future added value";
export type BrandLocationUpsertInput = {
  address: string;
  clientMutationId?: string | null | undefined;
  googlePlaceId: string;
  id?: string | null | undefined;
  point: GeoJsonTypeInput;
};
export type GeoJsonTypeInput = {
  coordinates: ReadonlyArray<number>;
  type: GeoJsonGeomType;
};
export type LocationsListItemAddMutation$variables = {
  input: BrandLocationUpsertInput;
};
export type LocationsListItemAddMutation$data = {
  readonly brandLocationUpsert: {
    readonly brand: {
      readonly " $fragmentSpreads": FragmentRefs<"LocationsList_brand">;
    };
    readonly brandLocation: {
      readonly id: string;
    };
  } | null | undefined;
};
export type LocationsListItemAddMutation = {
  response: LocationsListItemAddMutation$data;
  variables: LocationsListItemAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BrandLocationType",
  "kind": "LinkedField",
  "name": "brandLocation",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LocationsListItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandLocationUpsertPayload",
        "kind": "LinkedField",
        "name": "brandLocationUpsert",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LocationsList_brand"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LocationsListItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandLocationUpsertPayload",
        "kind": "LinkedField",
        "name": "brandLocationUpsert",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandLocationTypeConnection",
                "kind": "LinkedField",
                "name": "locations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandLocationTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BrandLocationType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "googlePlaceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GeoJsonType",
                            "kind": "LinkedField",
                            "name": "point",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "coordinates",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1d6a35287ae198ca3c6c02ef9de91eee",
    "id": null,
    "metadata": {},
    "name": "LocationsListItemAddMutation",
    "operationKind": "mutation",
    "text": "mutation LocationsListItemAddMutation(\n  $input: BrandLocationUpsertInput!\n) {\n  brandLocationUpsert(input: $input) {\n    brand {\n      ...LocationsList_brand\n      id\n    }\n    brandLocation {\n      id\n    }\n  }\n}\n\nfragment LocationsListItemDeleteButton_location on BrandLocationType {\n  id\n  address\n}\n\nfragment LocationsListItemDisplay_location on BrandLocationType {\n  id\n  address\n  ...LocationsListItemDeleteButton_location\n}\n\nfragment LocationsListItemEdit_location on BrandLocationType {\n  id\n  address\n  googlePlaceId\n  point {\n    coordinates\n  }\n}\n\nfragment LocationsListItem_location on BrandLocationType {\n  id\n  ...LocationsListItemDisplay_location\n  ...LocationsListItemEdit_location\n}\n\nfragment LocationsList_brand on BrandType {\n  id\n  locations {\n    edges {\n      node {\n        id\n        ...LocationsListItem_location\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "90ea5b6fa0d5a2381e3f59ffeaba4de4";

export default node;
